import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "flex justify-between items-center mb-6" }
const _hoisted_3 = { class: "mb-6 flex items-start space-x-6" }
const _hoisted_4 = { class: "w-1/2" }
const _hoisted_5 = { class: "subscription-input-container relative" }
const _hoisted_6 = { class: "mt-1 relative" }
const _hoisted_7 = {
  key: 0,
  class: "absolute z-50 mt-1 w-full bg-white dark:bg-gray-700 rounded-md shadow-lg border border-gray-200 dark:border-gray-600"
}
const _hoisted_8 = { class: "py-1" }
const _hoisted_9 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-500 dark:text-gray-400"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "w-1/2" }
const _hoisted_12 = {
  for: "search",
  class: "block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300"
}
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400 ml-1"
}
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = ["disabled", "placeholder"]
const _hoisted_16 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_17 = {
  key: 0,
  class: "bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 p-6"
}
const _hoisted_18 = {
  key: 1,
  class: "bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-red-100 dark:border-red-800 p-6"
}
const _hoisted_19 = { class: "flex items-center justify-center py-12 text-red-600 dark:text-red-400" }
const _hoisted_20 = {
  key: 2,
  class: "bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700/90 overflow-hidden"
}
const _hoisted_21 = {
  key: 0,
  class: "p-6 text-center text-gray-600 dark:text-gray-400"
}
const _hoisted_22 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_23 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700/30" }
const _hoisted_24 = { class: "bg-gray-50 dark:bg-gray-800/80 rounded-t-xl" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex items-center space-x-1" }
const _hoisted_27 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_28 = { class: "bg-white dark:bg-gray-800/90 divide-y divide-gray-200 dark:divide-gray-700/30" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_31 = { class: "text-sm font-medium text-gray-600 dark:text-gray-100" }
const _hoisted_32 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_33 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_34 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_35 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_36 = { class: "px-6 py-4" }
const _hoisted_37 = { class: "text-sm text-gray-600 dark:text-gray-300 font-mono" }
const _hoisted_38 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_39 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_40 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_41 = { class: "flex items-center space-x-3" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 0,
  class: "bg-gray-50 dark:bg-gray-700/90"
}
const _hoisted_45 = {
  colspan: "6",
  class: "px-6 py-4"
}
const _hoisted_46 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_47 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_48 = { class: "bg-white dark:bg-gray-800 p-4 rounded border border-indigo-200 dark:border-indigo-700 text-sm overflow-auto max-h-60 font-mono text-gray-800 dark:text-gray-200" }
const _hoisted_49 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-2" }
const _hoisted_50 = { class: "flex-1 flex justify-between sm:hidden" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" }
const _hoisted_54 = { class: "font-medium" }
const _hoisted_55 = { class: "font-medium" }
const _hoisted_56 = { class: "font-medium" }
const _hoisted_57 = {
  class: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px",
  "aria-label": "Pagination"
}
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = ["disabled"]
const _hoisted_63 = {
  key: 4,
  class: "fixed inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_64 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_65 = { class: "inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" }
const _hoisted_66 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-3" }

import { ref, computed, watch, onMounted, reactive, onUnmounted, inject, onBeforeMount } from 'vue'
import { packagesApiClient } from '../../services/api/packagesApiClient'
import type { WorkerFilter } from '../../types/workers-filter'
import CreateWorkerFilterModal from '../../components/features/workers-filter/CreateFilterModal.vue'
import Toast from '../../components/base/common/Toast.vue'
import { useTheme } from '../../utils/useTheme'
// Remove unused useRoute import

// Use theme via inject with a fallback

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const theme = inject('theme', useTheme())
// Remove unused route import

// Data
const workerFilters = ref<WorkerFilter[]>([])
const isLoading = ref(false)
const error = ref<string | null>(null)
const expandedRows = ref<Set<string>>(new Set())
const subscriptionName = ref('')
const searchQuery = ref('')

// Sorting
const sortField = ref('createdAt')
const sortOrder = ref<'asc' | 'desc'>('desc')

// Pagination
const currentPage = ref(1)
const itemsPerPage = ref(10)

// Table configuration
const columns = [
  {
    field: 'developerTopic',
    label: 'Developer Topic',
    sortable: true,
    searchable: true
  },
  {
    field: 'addedBy',
    label: 'Added By',
    sortable: true,
    searchable: true
  },
  {
    field: 'isIntegrations',
    label: 'IS INTEROP',
    sortable: true,
    formatter: (value: any) => {
      return value ? 'Yes' : 'No'
    }
  },
  {
    field: 'matchCondition',
    label: 'Match Condition',
    sortable: false,
    formatter: (value: Record<string, any> | null | undefined) => {
      if (!value || Object.keys(value).length === 0) return '-'
      const jsonStr = JSON.stringify(value)
      return jsonStr.length > 50 ? `${jsonStr.substring(0, 47)}...` : jsonStr
    }
  },
  {
    field: 'createdAt',
    label: 'Created',
    sortable: true,
    type: 'date'
  },
  {
    field: 'updatedAt',
    label: 'Updated',
    sortable: true,
    type: 'date'
  },
  {
    field: 'actions',
    label: 'Actions',
    sortable: false
  }
]

// Add this helper function for deep search
const deepSearch = (obj: any, searchText: string): boolean => {
  if (!obj) return false

  // Convert to lower case for case-insensitive search
  searchText = searchText.toLowerCase()

  // If it's a string, check if it contains the search text
  if (typeof obj === 'string') {
    return obj.toLowerCase().includes(searchText)
  }

  // If it's a number or boolean, convert to string and check
  if (typeof obj === 'number' || typeof obj === 'boolean') {
    return String(obj).toLowerCase().includes(searchText)
  }

  // If it's an array, search through all elements
  if (Array.isArray(obj)) {
    return obj.some((item) => deepSearch(item, searchText))
  }

  // If it's an object, search through all values
  if (typeof obj === 'object') {
    return Object.values(obj).some((value) => deepSearch(value, searchText))
  }

  return false
}

// Update the filteredData computed property
const filteredData = computed(() => {
  let result = [...workerFilters.value]

  // Apply search
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    result = result.filter((item) => {
      // Deep search through the entire item object
      return deepSearch(item, query)
    })
  }

  // Apply sorting
  if (sortField.value) {
    result.sort((a, b) => {
      const aVal = a[sortField.value as keyof WorkerFilter]
      const bVal = b[sortField.value as keyof WorkerFilter]

      // Handle undefined values
      if (aVal === undefined && bVal === undefined) return 0
      if (aVal === undefined) return 1
      if (bVal === undefined) return -1

      // Handle dates
      if (sortField.value === 'createdAt' || sortField.value === 'updatedAt') {
        const aDate = new Date(aVal as string).getTime()
        const bDate = new Date(bVal as string).getTime()
        const comparison = aDate > bDate ? 1 : -1
        return sortOrder.value === 'asc' ? comparison : -comparison
      }

      // Handle other fields
      const comparison = String(aVal) > String(bVal) ? 1 : -1
      return sortOrder.value === 'asc' ? comparison : -comparison
    })
  }

  return result
})

const totalPages = computed(() => Math.ceil(filteredData.value.length / itemsPerPage.value))

const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return filteredData.value.slice(start, end)
})

const displayedPages = computed(() => {
  const total = totalPages.value
  const current = currentPage.value
  const range: (number | string)[] = []

  if (total <= 7) {
    for (let i = 1; i <= total; i++) range.push(i)
  } else {
    if (current <= 3) {
      for (let i = 1; i <= 5; i++) range.push(i)
      range.push('...', total)
    } else if (current >= total - 2) {
      range.push(1, '...')
      for (let i = total - 4; i <= total; i++) range.push(i)
    } else {
      range.push(1, '...')
      for (let i = current - 1; i <= current + 1; i++) range.push(i)
      range.push('...', total)
    }
  }

  return range
})

// Methods
const handleSort = (field: string) => {
  if (sortField.value === field) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortField.value = field
    sortOrder.value = 'asc'
  }
}

const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return ''
  return new Date(dateString).toLocaleString()
}

const toggleExpand = (id: string) => {
  if (expandedRows.value.has(id)) {
    expandedRows.value.delete(id)
  } else {
    expandedRows.value.add(id)
  }
}

// Watch for search changes to reset pagination
watch(searchQuery, () => {
  currentPage.value = 1
  expandedRows.value.clear()
})

// Create a ref for the search input
const searchInput = ref<HTMLInputElement | null>(null)

// Update the fetchFilters function to focus the search input when data is loaded
const fetchFilters = async () => {
  if (!subscriptionName.value.trim()) {
    error.value = 'Please enter a subscription name'
    return
  }

  try {
    isLoading.value = true
    error.value = null
    const response = await packagesApiClient.get<WorkerFilter[]>(
      `/platform/workers/version-configs?subscription=${encodeURIComponent(subscriptionName.value.trim())}`
    )
    workerFilters.value = response

    // Focus the search input after data is loaded
    if (response.length > 0 && searchInput.value) {
      setTimeout(() => {
        searchInput.value?.focus()
      }, 100)
    }
  } catch (err) {
    error.value = 'Failed to load worker filters'
  } finally {
    isLoading.value = false
  }
}

// Lifecycle
onMounted(() => {
  // Only add event listener here, data is loaded in onBeforeMount
  document.addEventListener('click', handleClickOutside)
})

// Toast state
const toast = reactive({
  show: false,
  message: '',
  type: 'success' as 'success' | 'error',
  details: [] as string[]
})

const showToast = (message: string, type: 'success' | 'error', details?: string[]) => {
  toast.message = message
  toast.type = type
  toast.details = details || []
  toast.show = true
}

// Create Modal State
const showCreateModal = ref(false)

const handleCreated = () => {
  fetchFilters()
  showToast('Worker filter created successfully', 'success')
}

// Delete confirmation
const showDeleteConfirm = ref(false)
const filterToDelete = ref<string | null>(null)

const handleDeleteClick = (id: string, event: Event) => {
  event.stopPropagation() // Prevent row expansion
  filterToDelete.value = id
  showDeleteConfirm.value = true
}

const handleDelete = async () => {
  if (!filterToDelete.value) return

  try {
    await packagesApiClient.delete(`/platform/workers/version-configs/${filterToDelete.value}`)
    showToast('Filter deleted successfully', 'success')
    fetchFilters() // Refresh the list
  } catch (error: any) {
    let errorMessage = 'Failed to delete filter'
    if (error instanceof Error) {
      errorMessage = error.message
    }
    showToast('Failed to delete filter', 'error', [errorMessage])
  } finally {
    showDeleteConfirm.value = false
    filterToDelete.value = null
  }
}

// Typeahead state
const subscriptionSuggestions = ref<string[]>([])
const showSuggestions = ref(false)
const isLoadingSuggestions = ref(false)

// Debounce function
const debounce = (fn: Function, delay: number) => {
  let timeoutId: number | undefined
  return (...args: any[]) => {
    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId)
    }
    timeoutId = window.setTimeout(() => fn(...args), delay)
  }
}

// Watch subscription input for changes
watch(subscriptionName, (newValue) => {
  if (newValue.trim()) {
    // Show loading state immediately
    showSuggestions.value = true
    isLoadingSuggestions.value = true
    // Delay the API call
    debouncedFetchSuggestions(newValue)

    // If the value exactly matches a suggestion, fetch the filters
    if (subscriptionSuggestions.value.includes(newValue)) {
      fetchFilters()
    }
  } else {
    // Clear suggestions and hide loading for empty input
    subscriptionSuggestions.value = []
    showSuggestions.value = false
    isLoadingSuggestions.value = false

    // Also clear the loaded data and errors
    workerFilters.value = []
    error.value = null
  }
})

// Fetch suggestions
const fetchSuggestions = async (query: string) => {
  if (!query.trim()) {
    subscriptionSuggestions.value = []
    isLoadingSuggestions.value = false
    return
  }

  try {
    const response = await packagesApiClient.get<WorkerFilter[]>(
      `/platform/workers/version-configs?subscription=${encodeURIComponent(query)}`
    )
    // Extract unique subscription names from the response
    const uniqueSubscriptions = [...new Set(response.map((item) => item.subscription))].filter(
      Boolean
    )
    subscriptionSuggestions.value = uniqueSubscriptions
  } catch (error) {
    subscriptionSuggestions.value = []
  } finally {
    isLoadingSuggestions.value = false
  }
}

// Debounced version of fetchSuggestions with longer delay since we show loading immediately
const debouncedFetchSuggestions = debounce(fetchSuggestions, 500)

const handleSuggestionClick = (suggestion: string) => {
  subscriptionName.value = suggestion
  showSuggestions.value = false
  fetchFilters() // Keep this to load the data when a suggestion is selected
}

// Add blur handler for the input
const handleInputBlur = () => {
  // Small delay to allow click event on suggestions to fire first
  setTimeout(() => {
    showSuggestions.value = false
  }, 200)
}

// Close suggestions when clicking outside
const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  if (!target.closest('.subscription-input-container')) {
    showSuggestions.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

const handleKeydown = (event: KeyboardEvent) => {
  // If Escape key is pressed
  if (event.key === 'Escape') {
    showSuggestions.value = false
  }
}

// Edit state
const showEditModal = ref(false)
const filterToEdit = ref<WorkerFilter | null>(null)

const handleEditClick = (filter: WorkerFilter, event: Event) => {
  event.stopPropagation() // Prevent row expansion
  filterToEdit.value = filter
  showEditModal.value = true
}

const handleEditSubmit = async (updatedFilter: WorkerFilter) => {
  try {
    await packagesApiClient.put(`/platform/workers/version-configs/${updatedFilter._id}`, {
      subscription: updatedFilter.subscription,
      developerTopic: updatedFilter.developerTopic,
      addedBy: updatedFilter.addedBy,
      matchCondition: updatedFilter.matchCondition,
      isIntegrations: updatedFilter.isIntegrations
    })
    showToast('Filter updated successfully', 'success')
    fetchFilters() // Refresh the list
    showEditModal.value = false
    filterToEdit.value = null
  } catch (error: any) {
    let errorMessage = 'Failed to update filter'
    if (error instanceof Error) {
      errorMessage = error.message
    }
    showToast('Failed to update filter', 'error', [errorMessage])
  }
}

// Clear subscription input
const clearSubscription = () => {
  subscriptionName.value = ''
  workerFilters.value = []
  error.value = null
  subscriptionSuggestions.value = []
  showSuggestions.value = false
  isLoadingSuggestions.value = false
  searchQuery.value = ''

  // Save the cleared state explicitly
  saveFilterState()
}

// Save filter state to localStorage
const saveFilterState = () => {
  const filterState = {
    subscriptionName: subscriptionName.value,
    searchQuery: searchQuery.value
  }
  localStorage.setItem('workers-filter-state', JSON.stringify(filterState))
}

// Load filter state from localStorage
const loadFilterState = () => {
  try {
    const savedState = localStorage.getItem('workers-filter-state')
    if (savedState) {
      const parsedState = JSON.parse(savedState)
      subscriptionName.value = parsedState.subscriptionName || ''
      searchQuery.value = parsedState.searchQuery || ''

      // If we have a subscription, load its data
      if (subscriptionName.value) {
        fetchFilters()
      }
    }
  } catch (err) {
    // Remove console.error to fix build issue - fail silently for saved state loading
  }
}

// Initialize on component mount
onBeforeMount(() => {
  loadFilterState()
})

// Watch for filter changes and save state
watch(
  [subscriptionName, searchQuery],
  () => {
    saveFilterState()
  },
  { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "text-2xl font-bold text-gray-600 dark:text-gray-100" }, "Workers Filter", -1)),
      _createElementVNode("button", {
        class: "px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 flex items-center space-x-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateModal.value = true))
      }, _cache[15] || (_cache[15] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5",
          viewBox: "0 0 20 20",
          fill: "currentColor"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
            "clip-rule": "evenodd"
          })
        ], -1),
        _createElementVNode("span", null, "Create Filter", -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[19] || (_cache[19] = _createElementVNode("label", {
          for: "subscription",
          class: "block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300"
        }, "Subscription Name", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              id: "subscription",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subscriptionName).value = $event)),
              type: "text",
              class: "w-full px-3 py-2 rounded-md border focus:outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400 sm:text-sm bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100",
              placeholder: "e.g., crm-conversations-ai-inbound-events-sub",
              autocomplete: "off",
              spellcheck: "false",
              "aria-autocomplete": "none",
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (showSuggestions.value = true)),
              onBlur: handleInputBlur,
              onKeydown: handleKeydown
            }, null, 544), [
              [_vModelText, subscriptionName.value]
            ]),
            (subscriptionName.value.trim())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-400",
                  title: "Clear subscription",
                  onClick: clearSubscription,
                  onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                }, _cache[17] || (_cache[17] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-5 w-5",
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                      "clip-rule": "evenodd"
                    })
                  ], -1)
                ]), 32))
              : _createCommentVNode("", true)
          ]),
          (showSuggestions.value && (subscriptionSuggestions.value.length > 0 || isLoadingSuggestions.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (isLoadingSuggestions.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[18] || (_cache[18] = [
                        _createElementVNode("div", { class: "flex items-center" }, [
                          _createElementVNode("svg", {
                            class: "animate-spin h-4 w-4 mr-2 text-blue-500",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ]),
                          _createTextVNode(" Loading suggestions... ")
                        ], -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(subscriptionSuggestions.value, (suggestion) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: suggestion,
                          class: "w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-600 focus:text-gray-900 dark:focus:text-white",
                          onClick: ($event: any) => (handleSuggestionClick(suggestion))
                        }, _toDisplayString(suggestion), 9, _hoisted_10))
                      }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, [
          _cache[20] || (_cache[20] = _createTextVNode(" Search Routes ")),
          (!workerFilters.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " (Select a subscription first) "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            id: "search",
            ref_key: "searchInput",
            ref: searchInput,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            disabled: !workerFilters.value.length,
            class: _normalizeClass([
              'w-full pl-10 pr-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500',
              workerFilters.value.length
                ? 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100'
                : 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 text-gray-400 dark:text-gray-500 cursor-not-allowed'
            ]),
            placeholder: 
              workerFilters.value.length
                ? 'Search all fields (topic, author, integrations, match conditions)...'
                : 'Select a subscription to enable search'
            
          }, null, 10, _hoisted_15), [
            [_vModelText, searchQuery.value]
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["h-5 w-5", 
                workerFilters.value.length
                  ? 'text-gray-400 dark:text-gray-500'
                  : 'text-gray-300 dark:text-gray-600'
              ]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[21] || (_cache[21] = [
              _createElementVNode("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              }, null, -1)
            ]), 2))
          ])
        ])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[22] || (_cache[22] = [
          _createElementVNode("div", { class: "flex items-center justify-center py-12" }, [
            _createElementVNode("div", { class: "w-8 h-8 border-4 border-blue-600 rounded-full border-t-transparent animate-spin" }),
            _createElementVNode("span", { class: "ml-3 text-gray-600 dark:text-gray-400" }, "Loading filters...")
          ], -1)
        ])))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, _toDisplayString(error.value), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            (paginatedData.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " No filters found for this subscription. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("table", _hoisted_23, [
                    _createElementVNode("thead", _hoisted_24, [
                      _createElementVNode("tr", null, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                          return _createElementVNode("th", {
                            key: column.field,
                            class: _normalizeClass(["px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider first:rounded-tl-xl last:rounded-tr-xl", { 'cursor-pointer': column.sortable }]),
                            onClick: ($event: any) => (column.sortable && handleSort(column.field))
                          }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", null, _toDisplayString(column.label), 1),
                              (column.sortable)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                    (_openBlock(), _createElementBlock("svg", {
                                      class: _normalizeClass([
                        'w-3 h-3 transform',
                        sortField.value === column.field && sortOrder.value === 'asc'
                          ? 'text-blue-600 dark:text-blue-400'
                          : 'text-gray-400 dark:text-gray-500'
                      ]),
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }, _cache[23] || (_cache[23] = [
                                      _createElementVNode("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2",
                                        d: "M5 15l7-7 7 7"
                                      }, null, -1)
                                    ]), 2)),
                                    (_openBlock(), _createElementBlock("svg", {
                                      class: _normalizeClass([
                        'w-3 h-3 transform',
                        sortField.value === column.field && sortOrder.value === 'desc'
                          ? 'text-blue-600 dark:text-blue-400'
                          : 'text-gray-400 dark:text-gray-500'
                      ]),
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }, _cache[24] || (_cache[24] = [
                                      _createElementVNode("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2",
                                        d: "M19 9l-7 7-7-7"
                                      }, null, -1)
                                    ]), 2))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 10, _hoisted_25)
                        }), 64))
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item._id
                        }, [
                          _createElementVNode("tr", {
                            class: "hover:bg-gray-50 dark:hover:bg-gray-700/70 cursor-pointer transition-colors duration-200",
                            onClick: ($event: any) => (toggleExpand(item._id))
                          }, [
                            _createElementVNode("td", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, _toDisplayString(item.developerTopic), 1)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(item.addedBy || '-'), 1)
                            ]),
                            _createElementVNode("td", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([
                        item.isIntegrations
                          ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                          : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
                        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium'
                      ])
                                }, _toDisplayString(item.isIntegrations ? 'Yes' : 'No'), 3)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, _toDisplayString(columns
                        .find((col) => col.field === 'matchCondition')
                        ?.formatter?.(item.matchCondition)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(formatDate(item.createdAt)), 1),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(formatDate(item.updatedAt)), 1),
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("button", {
                                  class: "text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors",
                                  title: "Edit filter",
                                  onClick: ($event: any) => (handleEditClick(item, $event))
                                }, _cache[25] || (_cache[25] = [
                                  _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor"
                                  }, [
                                    _createElementVNode("path", { d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" })
                                  ], -1)
                                ]), 8, _hoisted_42),
                                _createElementVNode("button", {
                                  class: "text-rose-500 dark:text-red-400 hover:text-rose-600 dark:hover:text-red-300 transition-colors",
                                  title: "Delete filter",
                                  onClick: ($event: any) => (handleDeleteClick(item._id, $event))
                                }, _cache[26] || (_cache[26] = [
                                  _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "fill-rule": "evenodd",
                                      d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                                      "clip-rule": "evenodd"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_43)
                              ])
                            ])
                          ], 8, _hoisted_29),
                          (expandedRows.value.has(item._id))
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                                _createElementVNode("td", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    (Object.keys(item.matchCondition || {}).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                          _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "font-medium text-indigo-700 dark:text-indigo-400" }, " Match Condition ", -1)),
                                          _createElementVNode("pre", _hoisted_48, _toDisplayString(JSON.stringify(item.matchCondition, null, 2)), 1),
                                          _createElementVNode("p", _hoisted_49, " This condition is applied to the incoming payload. When matched, events are forwarded from the default subscription (" + _toDisplayString(item.subscription) + ") to your developer topic. ", 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])),
            (paginatedData.value.length > 0 && totalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass([
          _unref(theme).isDark.value ? 'border-gray-700' : 'border-gray-200',
          'px-4 py-3 border-t sm:px-6 flex items-center justify-between'
        ])
                }, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", {
                      disabled: currentPage.value === 1,
                      class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50',
              'relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md'
            ]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (currentPage.value--))
                    }, " Previous ", 10, _hoisted_51),
                    _createElementVNode("button", {
                      disabled: currentPage.value === totalPages.value,
                      class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50',
              'ml-3 relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md'
            ]),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (currentPage.value++))
                    }, " Next ", 10, _hoisted_52)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-600', 'text-sm'])
                      }, [
                        _cache[28] || (_cache[28] = _createTextVNode(" Showing ")),
                        _createElementVNode("span", _hoisted_54, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + 1), 1),
                        _cache[29] || (_cache[29] = _createTextVNode(" to ")),
                        _createElementVNode("span", _hoisted_55, _toDisplayString(Math.min(currentPage.value * itemsPerPage.value, filteredData.value.length)), 1),
                        _cache[30] || (_cache[30] = _createTextVNode(" of ")),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(filteredData.value.length), 1),
                        _cache[31] || (_cache[31] = _createTextVNode(" results "))
                      ], 2)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("nav", _hoisted_57, [
                        _createElementVNode("button", {
                          disabled: currentPage.value === 1,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 rounded-l-md border text-sm font-medium'
                ]),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (currentPage.value = 1))
                        }, _cache[32] || (_cache[32] = [
                          _createElementVNode("span", { class: "sr-only" }, "First", -1),
                          _createTextVNode(" ⟪ ")
                        ]), 10, _hoisted_58),
                        _createElementVNode("button", {
                          disabled: currentPage.value === 1,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 border text-sm font-medium'
                ]),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (currentPage.value--))
                        }, _cache[33] || (_cache[33] = [
                          _createElementVNode("span", { class: "sr-only" }, "Previous", -1),
                          _createTextVNode(" ⟨ ")
                        ]), 10, _hoisted_59),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedPages.value, (page) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
                            (page !== '...')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass([
                    currentPage.value === page
                      ? _unref(theme).isDark.value
                        ? 'z-10 bg-blue-900 border-blue-600 text-blue-300'
                        : 'z-10 bg-blue-50 border-blue-400 text-blue-500'
                      : _unref(theme).isDark.value
                        ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                        : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                    'relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                  ]),
                                  onClick: ($event: any) => (currentPage.value = Number(page))
                                }, _toDisplayString(page), 11, _hoisted_60))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass([
                    _unref(theme).isDark.value
                      ? 'border-gray-600 bg-gray-700 text-gray-400'
                      : 'border-gray-300 bg-white text-gray-700',
                    'relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                  ])
                                }, " ... ", 2))
                          ], 64))
                        }), 128)),
                        _createElementVNode("button", {
                          disabled: currentPage.value === totalPages.value,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 border text-sm font-medium'
                ]),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (currentPage.value++))
                        }, _cache[34] || (_cache[34] = [
                          _createElementVNode("span", { class: "sr-only" }, "Next", -1),
                          _createTextVNode(" ⟩ ")
                        ]), 10, _hoisted_61),
                        _createElementVNode("button", {
                          disabled: currentPage.value === totalPages.value,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 rounded-r-md border text-sm font-medium'
                ]),
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (currentPage.value = totalPages.value))
                        }, _cache[35] || (_cache[35] = [
                          _createElementVNode("span", { class: "sr-only" }, "Last", -1),
                          _createTextVNode(" ⟫ ")
                        ]), 10, _hoisted_62)
                      ])
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ])),
    (showEditModal.value)
      ? (_openBlock(), _createBlock(CreateWorkerFilterModal, {
          key: 3,
          modelValue: showEditModal.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showEditModal).value = $event)),
          "filter-data": filterToEdit.value,
          "edit-mode": true,
          onUpdated: handleEditSubmit
        }, null, 8, ["modelValue", "filter-data"]))
      : _createCommentVNode("", true),
    _createVNode(Toast, {
      show: toast.show,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((toast.show) = $event)),
      message: toast.message,
      type: toast.type,
      details: toast.details,
      duration: 5000
    }, null, 8, ["show", "message", "type", "details"]),
    (showDeleteConfirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _cache[37] || (_cache[37] = _createElementVNode("div", {
              class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", _hoisted_65, [
              _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4\" data-v-04f54317><div class=\"sm:flex sm:items-start\" data-v-04f54317><div class=\"mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-rose-100 dark:bg-red-900 sm:mx-0 sm:h-10 sm:w-10\" data-v-04f54317><svg class=\"h-6 w-6 text-rose-500 dark:text-red-400\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" data-v-04f54317><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z\" data-v-04f54317></path></svg></div><div class=\"mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left\" data-v-04f54317><h3 class=\"text-lg leading-6 font-medium text-gray-900 dark:text-gray-100\" data-v-04f54317> Delete Filter </h3><div class=\"mt-2\" data-v-04f54317><p class=\"text-sm text-gray-500 dark:text-gray-400\" data-v-04f54317> Are you sure you want to delete this filter? This action cannot be undone. </p></div></div></div></div>", 1)),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("button", {
                  type: "button",
                  class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-2.5 bg-rose-500 dark:bg-red-600 text-base font-medium text-white hover:bg-rose-600 dark:hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 dark:focus:ring-red-500 transition-colors duration-200 sm:w-auto sm:text-sm",
                  onClick: handleDelete
                }, " Delete "),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-6 py-2.5 bg-white dark:bg-gray-800 text-base font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400 sm:mt-0 sm:w-auto sm:text-sm",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (showDeleteConfirm.value = false))
                }, " Cancel ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(CreateWorkerFilterModal, {
      modelValue: showCreateModal.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((showCreateModal).value = $event)),
      subscription: subscriptionName.value,
      onCreated: handleCreated
    }, null, 8, ["modelValue", "subscription"])
  ]))
}
}

})